module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/home-logo.2b227ae6.svg";